import { useState, MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Divider, IconButton, Popover } from '@mui/material'

import Chip from '../common/chip'
import { BankAccount } from '../../types/user.types'
import BankIcon from '../../assets/icons/bank-icon.svg'
import MoreMenuIcon from '../../assets/icons/more-menu-icon.svg'
import { argentinianBankAccountType, brazilianBankAccountType, chileanBankAccountType, customersBankAccountType, peruvianBankAccountType } from '../../lib/common.lib'

const BankAccountListItem = ({
  bankAccountData,
  showMoreActionsButton,
  handleSetBankAccountAsMain,
  handleOpenDeleteBankAccountModal
}: {
  showMoreActionsButton: boolean
  bankAccountData: Partial<BankAccount>
  handleSetBankAccountAsMain: (bankAccountId: string) => void
  handleOpenDeleteBankAccountModal: (bankAccountToDelete: Partial<BankAccount>) => void
}) => {
  const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'

  const { t } = useTranslation(['bank-accounts-management'])
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

  const open = Boolean(anchorEl)
  const id = open ? 'simple-popover' : undefined

  return (
    <>
      <div className="users-management-user-data-container">
        <div className="bank-account-list-item-left-side">
          <div className="bank-account-list-item-left-item">
            <div className="bank-account-list-item-icon">
              <img
                src={BankIcon}
                alt="bank-icon"
              />
            </div>
            {selectedCountry === 'COL' || selectedCountry === 'ARG' || selectedCountry === 'CHI' || selectedCountry === 'PER' || selectedCountry === 'BRA' ? (
              <div className="bank-account-list-item-text">{bankAccountData?.bankName?.toUpperCase() || t('loading')}</div>
            ) : null}
            {selectedCountry === 'MEX' && <div className="bank-account-list-item-text">{bankAccountData?.bankAccountType?.toUpperCase() || t('loading')}</div>}
          </div>
          {selectedCountry === 'COL' && (
            <div className="bank-account-list-item-right-item">
              <div className="bank-account-list-item-text">{(customersBankAccountType as any)[bankAccountData?.bankAccountType || '2']?.toUpperCase()}</div>
            </div>
          )}
          {selectedCountry === 'ARG' && (
            <div className="bank-account-list-item-right-item">
              <div className="bank-account-list-item-text">{(argentinianBankAccountType as any)[bankAccountData?.bankAccountType || 'savings']?.toUpperCase()}</div>
            </div>
          )}
          {selectedCountry === 'CHI' && (
            <div className="bank-account-list-item-right-item">
              <div className="bank-account-list-item-text">{(chileanBankAccountType as any)[bankAccountData?.bankAccountType || 'savings']?.toUpperCase()}</div>
            </div>
          )}
          {selectedCountry === 'PER' && (
            <div className="bank-account-list-item-right-item">
              <div className="bank-account-list-item-text">{(peruvianBankAccountType as any)[bankAccountData?.bankAccountType || 'savings']?.toUpperCase()}</div>
            </div>
          )}
          {selectedCountry === 'BRA' && (
            <div className="bank-account-list-item-right-item">
              <div className="bank-account-list-item-text">{(brazilianBankAccountType as any)[bankAccountData?.bankAccountType || 'savings']?.toUpperCase()}</div>
            </div>
          )}
        </div>
        <div className="bank-account-list-item-right-side">
          <div className="bank-account-list-item-left-item">
            <div className="bank-account-list-item-text">{`No. ${bankAccountData?.bankNumber}`}</div>
          </div>
          <div className="bank-account-list-item-right-item">
            {bankAccountData?.bankAccountMain === true && (
              <div className="bank-account-list-main-account-tag">
                <Chip
                  status="main"
                  label={t('bankAccountListItem.chipText')}
                />
              </div>
            )}
            {showMoreActionsButton && (
              <div className="bank-account-list-more-actions-button">
                <IconButton
                  edge="end"
                  sx={{ color: '#107569' }}
                  onClick={(event: MouseEvent<HTMLButtonElement>) => {
                    event.stopPropagation()
                    setAnchorEl(event.currentTarget)
                  }}
                  aria-label="toggle password visibility"
                >
                  <img
                    src={MoreMenuIcon}
                    alt="more-menu-icon"
                  />
                </IconButton>
              </div>
            )}
          </div>
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={(event: MouseEvent<HTMLButtonElement>) => {
          event.stopPropagation()
          setAnchorEl(null)
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <div className="bank-account-list-item-popover-container">
          <div
            onClick={() => {
              setAnchorEl(null)
              handleOpenDeleteBankAccountModal(bankAccountData)
            }}
            className="bank-account-list-item-popover"
          >
            {t('bankAccountListItem.buttonsTexts.deleteAccount')}
          </div>
          {bankAccountData?.bankAccountMain !== true && (
            <>
              <Divider />
              <div
                onClick={() => {
                  setAnchorEl(null)
                  handleSetBankAccountAsMain(String(bankAccountData.bankNumber))
                }}
                className="bank-account-list-item-popover"
              >
                {t('bankAccountListItem.buttonsTexts.selectAsMain')}
              </div>
            </>
          )}
        </div>
      </Popover>
    </>
  )
}

export default BankAccountListItem
